<template>
<div class="booking_conf_wrap">
					<div class="title_top"> 
						<h2> Make payment at any eRemit Pay partners </h2>
						<h3> How to make payment ? </h3>
					</div>
					
				
					<div class="payment_proccess">
						 <ul>
								<li> 
									<span class="img_part"> <img src="/static/img/booking/bv.png"> </span>
									<span class="right_list">
										<h3> Book & Visit </h3>
										<p>Place a booking & visit any of our eRemit Pay partner nearest to you</p>
									</span>
								</li>
								<li class="middle"> 
									<span class="img_part"> <img src="/static/img/booking/sv.png"> </span>
									<span class="right_list">
										<h3>Show & Verify </h3>
										<p>Show your Booking Order No. to our partners and you will receive a confirmation SMS</p>
									</span>
								</li>
								<li> 
									<span class="img_part"> <img src="/static/img/booking/pay.png"> </span>
									<span class="right_list">
										<h3> Pay </h3>
										<p>Pay with cash or bank debit card. View receipt in-app & be notified via SMS or email
										</p>
									</span>
								</li>
						 </ul>
						 
					</div>
				 
					 
					 
					<div class="info_text"> Your booking is only valid for <strong>3 HOURS </strong> upon confirmation </div>
					<!-- <div class="term_condition"> -->
						 <!-- <label> -->
							<!-- <input type="radio" name="options" id="option2" autocomplete="off"> <span></span> I have read the Disclaimer & Accept all the <a href="#"> Terms and Conditions </a> -->
						  <!-- </label> -->
					<!-- </div> -->
					<!-- <div class="byclick"> -->
						<!-- By clicking “Next” below, I confirm that all the details above are correct and in order. -->
					<!-- </div> -->
				</div>
    
</template>

<script>
export default {
    
}
</script>
<style scoped>

	 .term_condition label {
		margin-right: 20px;
	}

 .term_condition  input[type="radio"] {
	  display: none;
	}
 .term_condition input[type="radio"] + span {
	  background-color: white;
	  border: 1px solid;
	  border-color: purple;
	  border-radius: 50px;
	  display: inline-block;
	  float: left;
	  margin-right: 8px;
	  padding: 8px;
	  top: 3px;
	  position: relative;
	  -webkit-appearance: none;
}
.term_condition input[type="radio"]:checked + span {
  color: #f00;
}
 .term_condition  input[type="radio"]:checked + span:after {
	  background: purple;
	  border-radius: 50px;
	  content: " ";
	  height: 10px;
	  width: 10px;
	  left: 3px;
	  position: absolute;
	  top: 3px; 
}
 .term_condition  label:hover input[type="radio"] + span {
		border-color: purple;
 }
 .title_top h2 {
    font-size: 17px;
    color: #003333;
}

.title_top h3 {
    color: #d5080f;
    font-size: 17px;
}

.title_top {
    margin-bottom: 2em;
}

.payment_proccess uL {
    list-style: none;
    margin: 0;
    padding: 0;
}

.payment_proccess uL li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 1em 0;
    position: relative;
}

.payment_proccess uL li .img_part {
    flex-basis: 12%;
    text-align: center;
}

.payment_proccess uL li span.right_list {
    flex-basis: 88%;
}

.payment_proccess uL li span.right_list h3 {
    font-size: 17px;
    color: #d5080f;
    font-weight: bold;
    margin: 0;
}

.payment_proccess uL li .img_part img {
    width: 31px;
}

.info_text {
    margin-top: 1em;
    margin-bottom: 3em;
}

.booking_conf_wrap {
    color: #003333;
}

.byclick {
    margin: 1em 0;
    font-weight: 300;
}

.term_condition label a {
    color: #be202e;
}
.payment_proccess ul li.middle:after {
    content: '';
    position: absolute;
    height: 31px;
    background: transparent;
    width: 11px;
    left: 12%;
    top: -35px;
    border-right: 5px dotted #be202e;
}
.payment_proccess ul li.middle:before {
    content: '';
    position: absolute;
    height: 31px;
    background: transparent;
    width: 11px;
    left: 12%;
    bottom: -27px;
    border-right: 5px dotted #be202e;
}

.payment_proccess uL li.middle {
    margin: 2em 0;
}
	
</style>